//#region src/schemas/http/lark-platform-registration-domains.json
var lark_platform_registration_domains_default = {
	feishu: {
		"accountDomain": "accounts.feishu.cn",
		"launcherHost": "open.feishu.cn"
	},
	lark: {
		"accountDomain": "accounts.larksuite.com",
		"launcherHost": "open.larksuite.com"
	}
};
//#endregion
export { lark_platform_registration_domains_default as default };

//# sourceMappingURL=lark-platform-registration-domains.js.map